import { useEffect, useRef } from "react"

const decimalCommaToDotString = (value) => {
  if (!value) return ""
  return String(value).replace(",", ".")
}

const formatDateToIso = (value) => {
  if (!value) return ""

  const parts = String(value).split("/")

  if (parts.length !== 3) return value

  const [dd, mm, yyyy] = parts
  return `${yyyy}-${mm}-${dd}`
}

const formatTaxa = (value) => {
  if (value === null || value === undefined || value === "") return ""

  const numero = Number(decimalCommaToDotString(value))

  if (Number.isNaN(numero)) return ""

  return numero.toFixed(2)
}

export const useEmitIdOrdinariosEffect = (formData, setFormData) => {
  const prevValuesRef = useRef(null)

  useEffect(() => {
    if (!formData?.caracteristicas || !formData?.datas) return

    const { caracteristicas, datas } = formData

    const gerarIdEmissao = () =>
      (
        `${caracteristicas.tipoAtivo || ""}_` +
        `${caracteristicas.cpfCnpjDevedor || caracteristicas.devedor || ""}_` +
        `${formatDateToIso(datas.dataEmissao)}_` +
        `${formatDateToIso(datas.dataVencimento)}_` +
        `${caracteristicas.indexador || ""}_` +
        `${formatTaxa(caracteristicas.taxaJuros)}`
      ).toUpperCase()

    const camposDependentes = {
      tipoAtivo: caracteristicas.tipoAtivo,
      devedor: caracteristicas.cpfCnpjDevedor || caracteristicas.devedor,
      dataEmissao: datas.dataEmissao,
      dataVencimento: datas.dataVencimento,
      indexador: caracteristicas.indexador,
      taxa: caracteristicas.taxaJuros
    }

    // primeira execução: só guarda valores (não sobrescreve ID vindo do backend)
    if (prevValuesRef.current === null) {
      prevValuesRef.current = camposDependentes
      return
    }

    const mudouCampoBase = Object.keys(camposDependentes).some(
      key => prevValuesRef.current[key] !== camposDependentes[key]
    )

    prevValuesRef.current = camposDependentes

    if (!mudouCampoBase) return

    const novoId = gerarIdEmissao()

    setFormData(prev => ({
      ...prev,
      caracteristicas: {
        ...prev.caracteristicas,
        emissao: novoId
      }
    }))
  }, [
  formData?.caracteristicas?.tipoAtivo,
  formData?.caracteristicas?.devedor,
  formData?.caracteristicas?.cpfCnpjDevedor,
  formData?.caracteristicas?.indexador,
  formData?.caracteristicas?.taxaJuros,
  formData?.datas?.dataEmissao,
  formData?.datas?.dataVencimento,
  setFormData
])
}